import { Controller } from "@hotwired/stimulus"

// Autosaves supervisor on/off flags to the server on each toggle change.
// Usage:
//   data-controller="supervisor-flags"
//   data-supervisor-flags-url-value="<%= save_supervisor_flags_path %>"
//
//   Each toggle input:
//   data-supervisor-flags-target="flag"
//   name="supervisor_flags[<name>]"
export default class extends Controller {
  static targets = ["flag", "status"]
  static values = { url: String }

  connect() {
    this._saveTimer = null
  }

  toggle() {
    clearTimeout(this._saveTimer)
    this._saveTimer = setTimeout(() => this.save(), 300)
  }

  async save() {
    const body = new FormData()
    this.flagTargets.forEach(input => {
      body.append(input.name, input.checked ? "true" : "false")
    })

    this._setStatus("Saving…")

    try {
      const token = document.querySelector('meta[name="csrf-token"]')?.content
      const res = await fetch(this.urlValue, {
        method: "PATCH",
        headers: { "X-CSRF-Token": token, Accept: "application/json" },
        body
      })

      if (res.ok) {
        this._setStatus("Saved", 2000)
      } else {
        this._setStatus("Error saving")
      }
    } catch {
      this._setStatus("Error saving")
    }
  }

  _setStatus(text, clearAfter = null) {
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = text
      if (clearAfter) {
        setTimeout(() => { this.statusTarget.textContent = "" }, clearAfter)
      }
    }
  }
}
